import { render, staticRenderFns } from "./InspectionButtons.vue?vue&type=template&id=7e4560c2&"
import script from "./InspectionButtons.vue?vue&type=script&lang=js&"
export * from "./InspectionButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports